import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 18l-2 -4l-7 -3.5a.55 .55 0 0 1 0 -1l18 -6.5l-2.901 8.034","key":"svg-0"}],["path",{"d":"M21.121 20.121a3 3 0 1 0 -4.242 0c.418 .419 1.125 1.045 2.121 1.879c1.051 -.89 1.759 -1.516 2.121 -1.879","key":"svg-1"}],["path",{"d":"M19 18v.01","key":"svg-2"}]]

const IconLocationPin = createReactComponent('outline', 'location-pin', 'LocationPin', __iconNode);

export default IconLocationPin;